import {
  Arrange,
  Container,
  Icon,
  SvgZap,
  Text,
  TextButton,
} from '@loomhq/lens';
import pluralize from 'pluralize';
import React from 'react';
import { useDispatch } from 'react-redux';

import { CLICKED_DISMISS_NOTIFICATIONS } from 'constants/events';
import { SHOW_MEMBER_VIDEO_THRESHOLD_BANNER } from 'constants/triggers';
import { completeTriggerCreator } from 'creators/triggers';
import * as analytics from 'utilities/analytics';

import BlockedNotificationsModal from 'components/blocked-notifications-modal';
import UpgradeButton from 'components/upgrade-button';

const MemberVideoThresholdBanner = ({ memberVideoLimit }) => {
  const dispatch = useDispatch();

  const onClickDismiss = () => {
    dispatch(completeTriggerCreator(SHOW_MEMBER_VIDEO_THRESHOLD_BANNER));

    analytics.track(CLICKED_DISMISS_NOTIFICATIONS, {
      location: 'sharePage',
    });
  };

  return (
    <Container
      className="my:medium"
      backgroundColor="upgrade"
      paddingTop="medium"
      paddingBottom="medium"
      paddingLeft="large"
      paddingRight="large"
      radius="medium"
    >
      <BlockedNotificationsModal location="sharePage" />
      <Arrange align="center" justifyContent="space-between">
        <Arrange align="center" gap="small" justifyContent="center">
          <Icon icon={<SvgZap />} />
          <Container>
            <Text isInline>
              You have a limit of {memberVideoLimit.limit} videos per person in
              the Workspace. You have space for{' '}
              <strong>
                {memberVideoLimit.remainingVideos} more{' '}
                {pluralize('video', memberVideoLimit.remainingVideos)}.
              </strong>
            </Text>
          </Container>
        </Arrange>
        <Arrange gap="medium">
          <UpgradeButton variant="neutral" hideIcon />
          <TextButton onClick={() => onClickDismiss()}>Dismiss</TextButton>
        </Arrange>
      </Arrange>
    </Container>
  );
};

export default MemberVideoThresholdBanner;
